module.exports = __webpack_public_path__ + "img/3.10b51698.jpg";